import React from "react";

const CardNew = ({ item, type = 1 }) => {
  const path = type == 1 ? "/news/detail_notice/" : "/news/detail_new/";

  return (
    <a
      href={path + item.id}
      className="row gx-0 mx-2 mx-md-0 px-3 py-2 my-2 my-md-0 align-items-center bg-white cursor-pointer border-bottom border-radius-sm-2px"
    >
      <div className="col-11">
        <div className="row gx-0">
          <div className="col-12 col-md-2 text-grey fs-13 fw-500">
            {item.posted}({item.day_of_week})
          </div>
          <div className="col-12 col-md-10 fw-600">{item.title}</div>
        </div>
      </div>
      <div className="col-1 color-more text-end fw-700">
        <span className="d-none d-md-inline-block">詳細</span>
        <span>
          <i className="bi bi-chevron-right"></i>
        </span>
      </div>
    </a>
  );
};

export default CardNew;
